<template>
  <div class="stay-overview-card">
    <div class="stay-image">
      <picture
        class="image-wrapper"
        v-lazyload="{
          src: stay.sitecoreContent.room.image,
          variant: 'room-overview'
        }"
      >
        <img
          class="image"
          src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
          :alt="stay.sitecoreContent.room.title"
        />
      </picture>
    </div>
    <div class="stay-description">
      <div class="stay-description-line box">
        <div class="section-label">{{tc('noums.roomSingular')}} {{index}}</div>
        <div class="overview-item guests">
          <div class="item-label bold-item">
            {{stay.sitecoreContent.room.title}} | {{stay.sitecoreContent.bed.title}}
          </div>
          <div class="item-value section-label" v-html="stayGuestsSummary" />
        </div>
        <a
          href="#"
          class="edit"
          @click.prevent="editStay"
          @keydown.space.prevent="editStay"
        >{{tc('booking.edit')}}</a>
        <hr>
        <div class="section-label">{{tc('noums.rateSingular')}}</div>
        <div class="overview-item">
          <div class="item-label bold-item">
            {{stay.sitecoreContent.rate.title}}
          </div>
          <div class="item-value">
            <div>{{avgPerNight}}</div>
            <div class="section-label capitalize">
              {{tc('booking.avgPerNight')}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  name: 'room-overview-card',
  props: {
    stay: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters('i18n', ['tc']),
    ...mapState('booking', ['query']),
    ...mapGetters('booking', ['getSummaryDetails']),
    ...mapGetters('currency', ['getDisplayPrice']),
    stayGuests() {
      if (this.index === 1) {
        return {
          adultGuestCount: this.query.adultGuestCount,
          childGuestCount: this.query.childGuestCount
        }
      } else {
        return this.query.aditionalGuests[this.index - 2]
      }
    },
    stayGuestsSummary() {
      return this.getSummaryDetails({ customQuery: this.stayGuests, separator: ',<br>' })
    },
    totalPerNight() {
      return this.stay ? this.stay.nightlyRates.map(n => Number(n.price)).reduce((a, b) => a + b) : 0
    },
    avgPerNight() {
      return this.getDisplayPrice({price: this.totalPerNight / this.stay.nightlyRates.length})
    }
  },
  methods: {
    ...mapActions('booking', ['selectRoom', 'goToStep']),
    async editStay() {
      await this.selectRoom(this.index - 1)
      await this.goToStep(0)
    }
  }
}
</script>